<template>
    <b-form-group>
        <template slot="label">
            <span>{{ $t('values.evaluateds') }}</span>
        </template>
        <select-with-avatar
            multiple
            close-on-select
            :selected="model"
            :options="options"
            :loading="isLoading"
            :internal-search="true"
            :next-page-button="nextPageButton"
            @changeValue="$emit('update:model', $event)"
            :placeholder="$t('form.placeholder.selectSomeEvaluated')"
            @click="loadOptions()"
            @nextPage="nextPage"
        />
    </b-form-group>
</template>
<script>
import { getUsers } from '@/views/values/api'
import { SelectWithAvatar } from '@/views/components/selects'
import { mapperToOptions } from '@/views/components/selects/select-with-avatar'
export default {
    components: {
        SelectWithAvatar,
    },
    props: {
        model: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            options: [],
            isLoading: false,
            pagination: {
                page: 1,
                lastPage: 1,
                perPage: 10,
            },
        }
    },
    methods: {
        resetPagination() {
            this.pagination.page = 1
            this.pagination.lastPage = 1
        },
        nextPage() {
            this.pagination.page++
            this.getUsers()
        },
        loadOptions() {
            if (this.options.length == 0) {
                this.getUsers()
            }
        },
        getUsers() {
            this.isLoading = true
            return getUsers({
                scopesNames: ['evaluated_users'],
                filter: 'id;picture;occupation;name',
                per_page: this.pagination.perPage,
                page: this.pagination.page,
            })
                .then((users) => {
                    let loadedOptions = mapperToOptions(users.data, 'id', 'name')
                    this.options = [...this.options, ...loadedOptions]
                    this.pagination.lastPage = users.last_page
                })
                .finally(() => {
                    this.isLoading = false
                    this.$emit('ready')
                })
        },
    },
    computed: {
        nextPageButton() {
            return {
                isShowNextPage: this.pagination.lastPage > 1,
                isLastPage: this.pagination.page == this.pagination.lastPage,
                loading: this.isLoading,
            }
        },
        areOptionsReady() {
            return this.options.length === 0
        },
    },
}
</script>
